function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".Juto_cookie_svg__cls-4{fill:#7c4a01}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M132.81 49.75a24.93 24.93 0 01-19.91-35.53 4.55 4.55 0 00-2.1-6 76.32 76.32 0 10-33.21 144.4c41.53-.68 75.18-35 75-76.57a76.23 76.23 0 00-4.09-24.42 4.59 4.59 0 00-5.72-2.89 24.88 24.88 0 01-9.97 1.01z",
  fill: "#e2a23b"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M148.55 51.64a4.59 4.59 0 00-5.72-2.89 24.93 24.93 0 01-29.93-34.53 4.55 4.55 0 00-2.1-6A75.92 75.92 0 0076.32 0v152.6h1.27c41.53-.68 75.18-35 75-76.57a76.23 76.23 0 00-4.04-24.39z",
  fill: "#e8bb62"
});

var _ref4 = /*#__PURE__*/React.createElement("circle", {
  cx: 63.56,
  cy: 49.88,
  r: 2.74
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M84.29 58.09a12.78 12.78 0 01-15.55.3",
  fill: "none",
  stroke: "#000",
  strokeLinecap: "round",
  strokeMiterlimit: 10
});

var _ref6 = /*#__PURE__*/React.createElement("circle", {
  cx: 89.08,
  cy: 49.88,
  r: 2.74
});

var _ref7 = /*#__PURE__*/React.createElement("ellipse", {
  className: "Juto_cookie_svg__cls-4",
  cx: 43.86,
  cy: 111.51,
  rx: 6.43,
  ry: 4.55
});

var _ref8 = /*#__PURE__*/React.createElement("ellipse", {
  className: "Juto_cookie_svg__cls-4",
  cx: 30.31,
  cy: 76.13,
  rx: 2.49,
  ry: 3.68,
  transform: "rotate(-65.79 30.308 76.125)"
});

var _ref9 = /*#__PURE__*/React.createElement("ellipse", {
  className: "Juto_cookie_svg__cls-4",
  cx: 73.38,
  cy: 81.56,
  rx: 5.78,
  ry: 3.65,
  transform: "rotate(-11.59 73.402 81.563)"
});

var _ref10 = /*#__PURE__*/React.createElement("ellipse", {
  className: "Juto_cookie_svg__cls-4",
  cx: 77.86,
  cy: 21.39,
  rx: 6.43,
  ry: 4.55,
  transform: "rotate(-35.84 77.842 21.398)"
});

var _ref11 = /*#__PURE__*/React.createElement("circle", {
  className: "Juto_cookie_svg__cls-4",
  cx: 118.03,
  cy: 65.43,
  r: 4.55
});

var _ref12 = /*#__PURE__*/React.createElement("ellipse", {
  className: "Juto_cookie_svg__cls-4",
  cx: 98.27,
  cy: 104.91,
  rx: 4.55,
  ry: 3.21,
  transform: "rotate(-69.15 98.265 104.91)"
});

var _ref13 = /*#__PURE__*/React.createElement("ellipse", {
  className: "Juto_cookie_svg__cls-4",
  cx: 130.57,
  cy: 109.46,
  rx: 3.21,
  ry: 4.55
});

var _ref14 = /*#__PURE__*/React.createElement("ellipse", {
  className: "Juto_cookie_svg__cls-4",
  cx: 139.78,
  cy: 76.32,
  rx: 6.43,
  ry: 4.55,
  transform: "rotate(-35.84 139.757 76.311)"
});

var _ref15 = /*#__PURE__*/React.createElement("ellipse", {
  className: "Juto_cookie_svg__cls-4",
  cx: 82.94,
  cy: 131.52,
  rx: 6.43,
  ry: 4.55
});

var _ref16 = /*#__PURE__*/React.createElement("ellipse", {
  className: "Juto_cookie_svg__cls-4",
  cx: 28.18,
  cy: 43.79,
  rx: 6.43,
  ry: 4.55
});

var _ref17 = /*#__PURE__*/React.createElement("ellipse", {
  className: "Juto_cookie_svg__cls-4",
  cx: 16.21,
  cy: 94.34,
  rx: 6.43,
  ry: 4.55
});

var SvgJutoCookie = function SvgJutoCookie(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "BACKGROUND 1",
    viewBox: "0 0 152.64 152.64"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17);
};

export default "data:image/svg+xml;base64,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";
export { SvgJutoCookie as ReactComponent };